<template>
  <div>
    <base-header class="pb-6"></base-header>
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header border-0">
          <h3 class="mb-0">Lista de Precantidades</h3>
        </div>
        <div class="row starter-page">
          <div class="container-fluid">
            <el-table
              class="table-responsive table-flush"
              header-row-class-name="thead-light"
              row-key="id"
              :data="historicData"
            >
              <!--    <el-table-column type="selection"
                       align="left"
                       min-width="120px">
              </el-table-column>-->

              <!-- <el-table-column label="Alimento" min-width="220px" prop="meal_id" sortable>
                <template v-slot="{row}">
                  <div class="table-user">
                    <img :src="'https://app.manzanaverde.pe/'+row.image_url" alt />
                    {{ row ? row.name.toUpperCase() : ''}}
                  </div>
                </template>
              </el-table-column>-->
              <el-table-column label="Semana" prop="week" width="270px" min-width="200px" sortable>
                <template v-slot="{row}">{{row.date}}</template>
              </el-table-column>
              <el-table-column
                label="Catering"
                prop="name"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{row}">{{row.name}}</template>
              </el-table-column>

              <el-table-column label="Reporte" prop="name" width="270px" min-width="200px" sortable>
                <template v-slot="{row}">
                  <base-button
                    type="danger"
                    :loading="row.id === loading_id"
                    @click="getPDF_historic(row.id,row.date,row.catering_id)"
                  >
                    <i class="far fa-file-pdf"></i> Descargar
                  </base-button>
                </template>
              </el-table-column>
              <!-- <el-table-column
                label="Descargar PDF"
                prop="subgroup_id"
                width="270px"
                min-width="200px"
                sortable
              >
                <template v-slot="{row}">
                  <a :href="baseUrl+date+'/'+user.data.catering_id+'/'+row.id">
                    <base-button type="danger">
                      <i class="far fa-file-pdf"></i> Descargar
                    </base-button>
                  </a>

                </template>
              </el-table-column>-->
            </el-table>
            <br />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import backofficeApi from "../../gateways/backoffice-api";

import axios from "axios";
import moment from "moment";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import StatsCard from "@/components/Cards/StatsCard";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Tooltip,
} from "element-ui";

export default {
  name: "starter-page",
  components: {
    StatsCard,
    RouteBreadCrumb,
    flatPicker,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
  },
  computed: {
    loading() {
      return this.$store.getters.getLoading;
    },
  },
  data() {
    return {
      loading_id: false,
      name: "",
      user: [],
      currentPage: 1,
      selectedRows: [],
      date: new Date().toISOString().substr(0, 10),
      subgroups: [],
      totalIngredients: [],
      ingredientsByMeal: [],
      meals: [],
      baseUrlSnack: [],
      meals_ordered: [],
      meals_ordered_var: [],
      historicData: [],
      dates: {
        simple: "2018-07-17",
      },
      baseUrl: null,
      ingredients: [],
    };
  },
  created() {
    this.get_precantidades();
  },
  watch: {},
  methods: {
    getfirstNLastDayWeek(curr) {
      // var curr =  Date.parse(curr);; // get current date
      // var curr = new Date(curr);
      // var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
      // var last = first + 6; // last day is the first day + 6

      // var firstday = new Date(curr.setDate(first)).toUTCString();
      // var lastday = new Date(curr.setDate(last)).toUTCString();

      const today = moment(curr);
      const firstday = today.clone().startOf("isoWeek");
      const lastday = today.clone().endOf("isoWeek");

      var obj = {
        first: moment(firstday).format("DD-MM-YY"),
        last: moment(lastday).format("DD-MM-YY"),
        firstDate: moment(firstday).format("YYYY-MM-DD"),
        lastDate: moment(lastday).format("YYYY-MM-DD"),
      };
      return obj;
    },
    get_precantidades() {
      axios
        .get("prequantities/get_all")
        .then((response) => {
          this.historicData = response.data.precantidades;
        })
        .catch((error) => console.log(error));
    },
    getPDF_historic(row_id, $date, $catering_id) {
      this.loading_id = row_id;
      backofficeApi({
        url: "prequantitiesBO/generate_pdf",
        responseType: "blob",
        method: "get",
        params: {
          date: $date,
          catering_id: $catering_id,
        },
      })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "precantidades-" + $date + ".pdf"
          );
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => console.log(error))
        .finally(() => {
          this.loading_id = null;
        });
    },
  },
};
</script>
<style>
.noMargin {
  margin-bottom: 0rem;
}

.starter-page {
  min-height: calc(100vh - 380px);
}
</style>
